import { render, staticRenderFns } from "./CuentasYPaquetes.vue?vue&type=template&id=852c5af0"
import script from "./CuentasYPaquetes.vue?vue&type=script&lang=js"
export * from "./CuentasYPaquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports